<div class="form">
  <h3>{{ 'dashboard.subscription.payment.modal.title' | translate }}</h3>
  <h4 class="section-title">
    {{ 'settings.payment.addNewPayment' | translate }}
  </h4>
  <div class="section-content">
    <app-bank-card-form
      [currentLanguage]="languageService.currentLanguage$ | async"
      (bankCardFormReady)="onBankCardFormReady($event)" />
  </div>
  <div class="form-actions">
    <kin-btn
      color="primary"
      [disabled]="bankCardForm?.invalid"
      (onClick)="onSave()">
      {{ 'settings.payment.save' | translate }}
    </kin-btn>
  </div>
</div>
